// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

// libraries
import User from '../lib/User.js'

class PeoplePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      companies: [],
      modalOpen: false,
    }
  }

  componentDidMount() {
    User.watch(this, () => {
      this.loadCompanies()
    })
  }

  loadCompanies = () => {
    window._api.get('/companies', (error, resp) => {
      if (error) {
        toast.error(error.message)
      }
      this.setState({ companies: resp.items })
    })
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  render() {
    let { companies, modalOpen } = this.state

    return (
      <div id="people-page">
        <Header
          title="People"
          actions={[
            {
              children: 'Create New People',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              name: 'Name',
              key: 'name',
              link: `/people/:_id`,
              sortable: true,
            },
            {
              key: 'company.name',
              link: `/companies/:company._id`,
              name: 'Company',
            },
            {
              name: 'Department',
              key: 'department',
            },
            {
              name: 'Position',
              key: 'position',
            },
            {
              key: 'email',
              name: 'Email',
            },
          ]}
          entities="people"
          fields={['name', 'company.name', 'department', 'position', 'email']}
          filters={[{ name: 'company', options: companies }]}
          searchable={true}
          sort_dir={1}
          sort_key={'name'}
        />
        <If condition={modalOpen}>
          <Dialog close={this.toggleModal} open={modalOpen}>
            <NewEntityDialog
              close={this.toggleModal}
              entities="people"
              title="Enter a name for the new Person"
            />
          </Dialog>
        </If>
      </div>
    )
  }
}

// export
export default PeoplePage
